// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  orgId: __t.u64().primaryKey().name("org_id"),
  perTurnMaxTokens: __t.u32().name("per_turn_max_tokens"),
  dailyCostCapMicros: __t.i64().name("daily_cost_cap_micros"),
  monthlyCostCapMicros: __t.i64().name("monthly_cost_cap_micros"),
  softLimit: __t.bool().name("soft_limit"),
  updatedAt: __t.i64().name("updated_at"),
});
